/**
 * De stations van de T- en L-MATIC (`heenEnWeer.ts`, 21 oktober): een geel
 * kader op de vloer waar een pallet neergezet wordt, en voor de L-MATIC een
 * overslagstation van 1 m hoog aan de productiekant.
 *
 * Het overslagstation is een stellage met twee liggers dwars op de rijbaan,
 * 0,9 m uit elkaar onder de lange zijde van de pallet, op vier gele poten
 * 1,1 m uit elkaar — ruim genoeg dat de wielarmen van de L-MATIC er tussendoor
 * passen als hij eronder rijdt.
 */

/** Een geel kader van 1,5 m rond een palletplek, zoals bij de C-MATIC-stations. */
export function Vloerkader({ x, z }: { x: number; z: number }) {
  return (
    <group position={[x, 0, z]}>
      {([[0, 0.62, 1.5, 0.06], [0, -0.62, 1.5, 0.06], [0.72, 0, 0.06, 1.3], [-0.72, 0, 0.06, 1.3]] as const).map(
        ([dx, dz, b, d], i) => (
          <mesh key={i} position={[dx, 0.0025, dz]} rotation={[-Math.PI / 2, 0, 0]} receiveShadow>
            <planeGeometry args={[b, d]} />
            <meshStandardMaterial color="#e6b400" roughness={0.7} polygonOffset polygonOffsetFactor={-2} />
          </mesh>
        ),
      )}
    </group>
  )
}

/** Het overslagstation: de pallet staat met zijn onderkant op `hoogte`. */
export function Overslagstation({ x, z, hoogte }: { x: number; z: number; hoogte: number }) {
  const ligger = 0.08
  return (
    <group position={[x, 0, z]}>
      {[-0.45, 0.45].map((dx) => (
        <mesh key={dx} position={[dx, hoogte - ligger / 2, 0]} castShadow receiveShadow>
          <boxGeometry args={[0.06, ligger, 1.16]} />
          <meshStandardMaterial color="#5d636b" roughness={0.55} metalness={0.3} />
        </mesh>
      ))}
      {[-0.45, 0.45].map((dx) =>
        [-0.55, 0.55].map((dz) => (
          <group key={`${dx}${dz}`} position={[dx, 0, dz]}>
            <mesh position={[0, (hoogte - ligger) / 2, 0]} castShadow receiveShadow>
              <boxGeometry args={[0.06, hoogte - ligger, 0.06]} />
              <meshStandardMaterial color="#f2c200" roughness={0.5} metalness={0.1} />
            </mesh>
            {/* Voetplaat met vier bouten, zoals onder een staander. */}
            <mesh position={[0, 0.004, 0]} receiveShadow>
              <boxGeometry args={[0.14, 0.008, 0.14]} />
              <meshStandardMaterial color="#3b3f45" roughness={0.6} metalness={0.4} />
            </mesh>
          </group>
        )),
      )}
    </group>
  )
}
